// JsFromRoutes CacheKey 6fc6ce7010e164381102f3b9c4996ac1
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  new: /* #__PURE__ */ definePathHelper('get', '/login'),
  create: /* #__PURE__ */ definePathHelper('post', '/login'),
  destroy: /* #__PURE__ */ definePathHelper('post', '/logout'),
}
